export const SUPPORTED_MISSION_TYPES = ['tagging', 'classifier', 'multilabel'];

export const BOOLEAN_SELECT_ITEMS = [
  { caption: '-', value: null },
  { caption: 'Yes', value: '1' },
  { caption: 'No', value: '0' },
];

export const TABS = [
  { caption: 'Yes', value: 'yes' },
  { caption: 'No', value: 'no' },
  { caption: 'Unknown', value: 'unknown' },
  { caption: 'Not tagged', value: 'null' },
];

export const IMAGES_BASE_URL = 'https://images.heuritech.com';
